<template>
  <div class="page-box" style="position: relative;">
    <el-form ref="areaWorkListFilter" :model="areaWorkList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350"
        @search="refreshAreaWorkList(true)"
        @reset="onResetAreaWorkList"
      >
<!--        <el-form-item label="创建人" prop="formFilter.createUserId">-->
<!--          <el-input class="filter-item" v-model="areaWorkList.formFilter.createUserId"-->
<!--            :clearable="true" placeholder="创建人"-->
<!--          />-->
<!--        </el-form-item>-->
        <el-form-item label="创建时间" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="areaWorkList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="组织部门" prop="formFilter.orgCode">
          <el-select class="filter-item" v-model="areaWorkList.formFilter.orgCode" :clearable="true" filterable
            placeholder="组织部门" :loading="areaWorkList.orgCode.impl.loading"
            @visible-change="areaWorkList.orgCode.impl.onVisibleChange"
            @change="onOrgCodeValueChange">
            <el-option v-for="item in areaWorkList.orgCode.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否媒体采用" prop="formFilter.mediaAdoption">
          <el-select class="filter-item" v-model="areaWorkList.formFilter.mediaAdoption" :clearable="true" filterable
            placeholder="是否媒体采用" :loading="areaWorkList.mediaAdoption.impl.loading"
            @visible-change="areaWorkList.mediaAdoption.impl.onVisibleChange"
            @change="onMediaAdoptionValueChange">
            <el-option v-for="item in areaWorkList.mediaAdoption.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetAreaWorkList">重置</el-button>

        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshAreaWorkList(true)">查询
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('areaWorkList:areaWorkList:areaWorkFormAdd')"
                   @click="onAreaWorkFormAddClick()">
          新增
        </el-button>
      </filter-box>
    </el-form>
      <el-table ref="areaWork"  header-cell-class-name="table-header-gray"
        :data="areaWorkList.AreaWork.impl.dataList" :size="defaultFormItemSize"
        @sort-change="areaWorkList.AreaWork.impl.onSortChange"
        @refresh="refreshAreaWorkList(true)"
      >
        <!-- 表格操作 -->

        <!-- 表格列 -->
        <el-table-column label="序号" type="index" width="50px" :index="areaWorkList.AreaWork.impl.getTableIndex" />
        <el-table-column label="创建人" prop="createUserIdDictMap.name" />
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">
            <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="辖区" prop="orgCodeDictMap.name" />
        <el-table-column label="活动内容" prop="workContent" />
        <el-table-column label="是否媒体采用" prop="mediaAdoption">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.mediaAdoptionDictMap.name" placement="top">
              <el-switch
                @change="switchChange($event, scope.row)"
                v-model="scope.row.mediaAdoption"
                active-color="#13ce66"
                inactive-color="#C0C0C0"
                active-value="1"
                inactive-value="0"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-tooltip>
          </template>

        </el-table-column>
        <el-table-column label="现场图片" min-width="100px">
          <template slot-scope="scope">
            <el-image v-for="item in parseUploadData(scope.row.siteImages, {id: scope.row.id, fieldName: 'siteImages', asImage: true})"
                      :preview-src-list="getPictureList(scope.row.siteImages, {id: scope.row.id, fieldName: 'siteImages', asImage: true})"
                      class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
              <div slot="error" class="table-cell-image">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click.stop="onAreaWorkFormUpdateClick(scope.row)" type="text" :size="defaultFormItemSize"
              :disabled="!checkPermCodeExist('areaWorkList:areaWorkList:areaWorkFormUpdate')">
              编辑
            </el-button>
            <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
              :disabled="!checkPermCodeExist('areaWorkList:areaWorkList:delete')">
              删除
            </el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="table-empty unified-font">
            <img src="@/assets/img/empty.png">
            <span>暂无数据</span>
          </div>
        </template>
        <!-- 分页 -->

      </el-table>
    <el-row slot="pagination" type="flex" justify="end" style="margin-top: 10px;">
      <el-pagination
        :total="areaWorkList.AreaWork.impl.totalCount"
        :current-page="areaWorkList.AreaWork.impl.currentPage"
        :page-size="areaWorkList.AreaWork.impl.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, prev, pager, next, sizes"
        @current-change="areaWorkList.AreaWork.impl.onCurrentPageChange"
        @size-change="areaWorkList.AreaWork.impl.onPageSizeChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { AreaWorkController, DictionaryController } from '@/api';

export default {
  name: 'areaWorkList',
  props: {
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      areaWorkList: {
        formFilter: {
          createUserId: undefined,
          createTime: [],
          orgCode: undefined,
          mediaAdoption: undefined
        },
        formFilterCopy: {
          createUserId: undefined,
          createTime: [],
          orgCode: undefined,
          mediaAdoption: undefined
        },
        orgCode: {
          impl: new DropdownWidget(this.loadOrgCodeDropdownList)
        },
        AreaWork: {
          impl: new TableWidget(this.loadAreaWorkWidgetData, this.loadAreaWorkVerify, true, false, 'createTime', 0)
        },
        mediaAdoption: {
          impl: new DropdownWidget(this.loadMediaAdoptionDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetAreaWorkList () {
      this.$refs.areaWorkListFilter.resetFields();
      this.refreshAreaWorkList(true);
    },
    /**
     * 辖区工作数据获取函数，返回Promise
     */
    loadAreaWorkWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        areaWorkDtoFilter: {
          createTimeStart: Array.isArray(this.areaWorkList.formFilterCopy.createTime) ? this.areaWorkList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.areaWorkList.formFilterCopy.createTime) ? this.areaWorkList.formFilterCopy.createTime[1] : undefined,
          mediaAdoption: this.areaWorkList.formFilterCopy.mediaAdoption,
          orgCode: this.areaWorkList.formFilterCopy.orgCode
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        AreaWorkController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 辖区工作数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadAreaWorkVerify () {
      this.areaWorkList.formFilterCopy.createTime = this.areaWorkList.formFilter.createTime;
      this.areaWorkList.formFilterCopy.mediaAdoption = this.areaWorkList.formFilter.mediaAdoption;
      this.areaWorkList.formFilterCopy.orgCode = this.areaWorkList.formFilter.orgCode;
      return true;
    },
    /**
     * 组织部门下拉数据获取函数
     */
    loadOrgCodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {parentId: '1526381006418874368'};
        DictionaryController.dictSysDeptByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 组织部门选中值改变
     */
    onOrgCodeValueChange (value) {
    },
    /**
     * 是否媒体采用下拉数据获取函数
     */
    loadMediaAdoptionDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否媒体采用选中值改变
     */
    onMediaAdoptionValueChange (value) {
    },
    /**
     * 更新辖区工作列表
     */
    refreshAreaWorkList (reloadData = false) {
      if (reloadData) {
        this.areaWorkList.AreaWork.impl.refreshTable(true, 1);
      } else {
        this.areaWorkList.AreaWork.impl.refreshTable();
      }
      if (!this.areaWorkList.isInit) {
        // 初始化下拉数据
      }
      this.areaWorkList.isInit = true;
    },
    /**
     * 新增
     */
    onAreaWorkFormAddClick () {
      let params = {};

      params.closeVisible = 1;
      this.$router.push({name: 'areaWorkForm', query: params});
    },
    /**
     * 编辑
     */
    onAreaWorkFormUpdateClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'areaWorkForm', query: params});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      AreaWorkController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.areaWorkList.AreaWork.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    switchChange (event, row) {
      row.mediaAdoption = event
      let params = {
        areaWorkDto: {
          ...row
        }
      };
      AreaWorkController.update(this, params).then(res => {
        this.areaWorkList.AreaWork.impl.refreshTable();
      }).catch(e => {});
    },
    onResume () {
      this.refreshAreaWorkList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshAreaWorkList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
